"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsersListDialog = void 0;

var _VideoPlayer = require("../VideoPlayer");

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

require("./UsersListDialog.css");

var _Tracker = require("../../util/Tracker");

var _Modal = require("../../molecules/Modal");

var _atoms = require("../../atoms");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Users List Dialog
var UsersListDialog = function UsersListDialog(_ref) {
  var open = _ref.open,
      users = _ref.users,
      title = _ref.title,
      onClose = _ref.onClose,
      onUserClick = _ref.onUserClick,
      anonymousUsers = _ref.anonymousUsers,
      hideCloseButton = _ref.hideCloseButton,
      disableAnonymousUserClick = _ref.disableAnonymousUserClick;

  var _useVideoSuspenders = (0, _VideoPlayer.useVideoSuspenders)(),
      suspend = _useVideoSuspenders.suspend,
      resume = _useVideoSuspenders.resume;

  (0, _react.useEffect)(function () {
    if (open) {
      suspend();
    } else {
      resume();
    }
  }, [suspend, resume, open]);

  var handleUserOnClick = function handleUserOnClick(e, user) {
    if (typeof onUserClick === "function") {
      (0, _Tracker.trackEvent)({
        action: "User who watched Pressed",
        element: e
      });
      onUserClick(e, user);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    open: open,
    className: "UsersListDialog",
    trkContext: "UsersListDialog",
    onShadeClick: function onShadeClick() {
      return onClose();
    },
    fillScreen: false
  }, /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    hideCloseButton: hideCloseButton,
    onCloseClick: function onCloseClick() {
      if (typeof onClose === "function") {
        onClose();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_.ModalTitle, {
    content: title
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, {
    alignItems: "center",
    className: "user-list-dialog-content-section"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "list"
  }, users && users.map(function (user) {
    var userId = user.user_id;
    var firstName = user.first_name;
    var lastName = user.last_name;
    var name = firstName && lastName ? firstName + " " + lastName : firstName ? firstName : lastName;
    return /*#__PURE__*/_react.default.createElement(_.Row, {
      className: "user-item",
      alignItems: "center",
      justifyContent: "flex-start",
      onClick: function onClick(e) {
        return handleUserOnClick(e, user);
      }
    }, /*#__PURE__*/_react.default.createElement(_.Avatar, {
      className: "user-avatar",
      size: 40,
      imageUrl: "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(userId),
      initials: (0, _.getInitials)(firstName, lastName),
      marginLeft: "2",
      marginRight: "2"
    }), /*#__PURE__*/_react.default.createElement(_.Label, null, name));
  }), anonymousUsers && anonymousUsers.map(function (anonymousUser) {
    var count = anonymousUser.count ? anonymousUser.count : null;
    var state = anonymousUser.state ? anonymousUser.state : null;
    var countText = count > 1 ? "".concat(count, " people") : "".concat(count, " person");
    var text = "".concat(countText, " from ").concat(state);
    var users = [];
    var maxCount = Math.min(3, count);

    for (var i = 0; i < maxCount; i++) {
      users.push({
        user_id: null
      });
    }

    if (!count || !state) {
      return null;
    } else {
      return /*#__PURE__*/_react.default.createElement(_.Row, {
        className: "user-item anonymous",
        alignItems: "center",
        justifyContent: "flex-start",
        onClick: function onClick(e) {
          if (!disableAnonymousUserClick) {
            handleUserOnClick(e, anonymousUser);
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_.StackedAvatars, {
        users: users,
        marginLeft: "2",
        marginRight: "2"
      }), /*#__PURE__*/_react.default.createElement(_.Label, null, text));
    }
  }))));
};

exports.UsersListDialog = UsersListDialog;
UsersListDialog.defaultProps = {
  title: "Users"
};